import { useCallback } from 'react';

import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { PractitionerUpdatePermissionsModal } from './PractitionerUpdatePermissionsModal';

type PractitionerUpdatePermissiosnModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type PractitionerUpdatePermissionsModalOpenerProps = {
   readonly children: (renderProps: PractitionerUpdatePermissiosnModalOpenerRenderProps) => JSX.Element;
   readonly onUpdate: VoidFunction;
   readonly practitioner: PractitionerView;
};

export const PractitionerUpdatePermissionsModalOpener = (
   props: PractitionerUpdatePermissionsModalOpenerProps
): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   const handleUpdate = useCallback(() => {
      closeModal();
      props.onUpdate();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [closeModal, props.onUpdate]);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}
         {modalOpened ? (
            <PractitionerUpdatePermissionsModal
               onUpdate={handleUpdate}
               onCancel={closeModal}
               practitioner={props.practitioner}
            />
         ) : null}
      </>
   );
};
